import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, Stack } from '@mui/material'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import { fetchLogin, selectAuthentications, initialize } from 'slices/authenticationsSlice'
import { LoadingTypes } from 'slices/types'
import { ConfirmDialog } from 'components/dialog/ConfirmDialog'
import { CustomGrid } from 'components/grid/CustomGrid'
import { PasswordInput } from 'components/input/PasswordInput'
import { TextInput } from 'components/input/TextInput'

const Login = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { loading } = useAppSelector(selectAuthentications)

  const [inputValue, setInputValue] = useState({ userId: '', password: '' })
  const [valid, setValid] = useState({ userId: true, password: true })
  const [paramsKey, setParamsKey] = useState('')

  const disabled = useMemo(() => !valid.userId || !valid.userId, [valid])

  const handleSubmit = () => {
    dispatch(fetchLogin({ ...inputValue, key: paramsKey }))
  }
  const handleDialogClose = () => {
    dispatch(initialize())
  }

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    setParamsKey(params.get('key') ?? '')
  }, [])

  return (
    <Box width="600px" px={2}>
      <CustomGrid label="ID">
        <TextInput
          value={inputValue.userId}
          placeholder="ID"
          maxLength={50}
          setValid={userId => setValid({ ...valid, userId })}
          onChange={userId => setInputValue({ ...inputValue, userId })}
        />
      </CustomGrid>
      <CustomGrid label={t('autentication.password')}>
        <PasswordInput
          value={inputValue.password}
          placeholder={t('autentication.password')}
          maxLength={50}
          setValid={password => setValid({ ...valid, password })}
          onChange={password => setInputValue({ ...inputValue, password })}
        />
      </CustomGrid>
      <Stack direction="row" justifyContent="flex-end">
        <Button variant="contained" sx={{ width: '100px' }} disabled={disabled} onClick={handleSubmit}>
          {t('autentication.login')}
        </Button>
      </Stack>
      <ConfirmDialog open={loading === LoadingTypes.Failed} label={t('common.close')} onSubmit={handleDialogClose}>
        {t('error.login')}
      </ConfirmDialog>
    </Box>
  )
}

export default Login
